export default "__VITE_ASSET__pJQiJbtP__"